const Kz = {
  translation: {
    error: {
      doNotHaveAccessToViewThisModule: 'Сізде бұл модульді көруге рұқсат жоқ',
      dataEnteredIncorrectly: 'Деректер қате енгізілді',
      pleaseFillInTheHighlightedFields: 'Көрсетілген өрістерді толтырыңыз',
      errorSavingReport: 'Есепті сақтау кезінде қате пайда болды',
    },
    main: {
      SCcontrolPanel: 'СК басқару панелі',
      exit: 'Шығу',
      instruction: 'Нұсқаулық',
    },
    sideBar: {
      roadRepairPlans: 'Жолдарды жөндеу жоспары',
      intersections: 'Қиылысу',
      addRoadRepairPlan: 'Жолды жөндеу жоспарын қосу',
      configuringUsers: 'Пайдаланушыны қалыпқа келтіру',
      settingUpRoles: 'Рөлдерді қалыпқа келтіру',
      settingUpDirectories: 'Анықтамалықтарды қалыпқа келтіру',
      userActions: 'Пайдаланушы әрекеттері',
      updateData: 'Деректерді жаңарту',
      videoStreams: 'Бейне ағындар',
      healthCare: 'Денсаулық сақтау',
      analytics: 'Аналитикалық көрсеткіштер',
      gosuslugy: 'Мемлекеттік қызметтер',
      preschools: 'Білім беру',
      budget: 'Кірістер мен шығыстар (жинақталған және жинақталмаған)',
      budgetEntering: 'Кірістер мен шығыстар',
      schools: 'Мектептер',
    },
    roadRepairPlan: {
      allRoadRepairPlans: 'Жол жөндеудің барлық жоспарлары',
      responsible: 'Жауапты',
      categoryOfWork: 'Жұмыс санаты',
      plot: 'Учаскесі',
      street: 'Көше',
      contractor: 'Мердігер',
      hiddenWork: 'Жасырын жұмыс',
      start: 'Басталуы',
      end: 'Аяқталуы',
      action: 'Әрекет',
      edit: 'Редакциялау',
      delete: 'Өшіру',

      search: 'Іздеу',
      reset: 'Қалпына келтіру',
      exactlyWantToDelete: 'Дәл жою керек',
      loadingPleaseWait: 'Жүктелуде, күтіңіз',
      removed: 'Жойылды',
      yes: 'Иә',
      no: 'Жоқ',
    },
    intersections: {
      allIntersections: 'Барлық қиылыстар',
      act: 'Әрекет',
      responsible: 'Жауапты',
      categoryOfWork: 'Жұмыс санаты',
      street: 'Көше',
      contractor: 'Мердігер',
      action: 'Әрекет',
      delete: 'Өшіру',
      edit: 'Редакциялау',

      exactlyWantToDelete: 'Есепті жойғыңыз келетініне сенімдісіз бе',
      loadingPleaseWait: 'Жүктелуде, күтіңіз',
      removed: 'Жойылды',
      obligatoryField: 'Міндетті өріс',
    },
    addRoadRepairPlan: {
      addingNewRoadRepairPlan: 'Жаңа жол жөндеу жоспарын қосу',
      crossing: 'Қиылысу',
      chooseTheResponsible: 'Жауапты адамды таңдау',
      selectCategoryOfWork: 'Жұмыс санатын таңдау',
      replacingTheWaterSupply: 'Су құбырын ауыстыру',
      overhaulOfRoads: 'Жолдарды күрделі жөндеу',
      pipeReconstruction: 'Құбырды қайта жөндеу',
      mediumRoadRepair: 'Жолдарды орташа жөндеу',
      roadMaintenance: 'Жолдарды ағымдағы жөндеу',
      overlappingTheStreet: 'Көшені жабу',
      objectTypeOnTheMap: 'Картадағы нысан түрі',
      coordinates: 'Координаттары',
      label: 'Белгі',
      polygon: 'Полигон',
      dateOfThePlannedStartOfWork: 'Жұмыстардың жоспарланған басталу күні',
      beginningOfWork: 'Жұмыстың басталуы',
      incompleteDateOfThePlannedStartOfWork: 'Жұмыстардың жоспарланған бастаудың нақыт',
      plannedCompletionDate: 'Жұмыстарды жоспарлы аяқтау күні',
      completionOfWork: 'Жұмыстарды аяқтау',
      incompleteDateOfThePlannedCompletionOfWork: 'Жұмыстарды жоспарлы аяқтаудың нықты емес күні',
      chooseContractor: 'Мердігерді таңдаңыз',
      responsibleRepairContacts: 'Жөндеуге жауапты тұлғаның байланыс деректері',
      selectRepairExecutionStatus: 'Жұмысты орындау түрін таңдаңыз',
      inWork: 'Жұмыста',
      performed: 'Орындалды',
      scheduledRepairs: 'Жоспарланған жұмыс',
      projectCost: 'Жобаның құны',
      theAmountPlannedFor2021: '2021 жылға жоспарланған сома',
      hideThisRoadRepairPlan: 'Жолдарды жөндеу жоспарының кезеңдерін жасыру',
      addTo: 'Қосу',
      yes: 'Иә',
      no: 'Жоқ',
      responsible: 'Жауапты',
      street: 'Көше',
      plot: 'Учаскесі',
      selectCategory: 'Саннаты таңдаңыз',
      openingOfTheRoadway: 'Жол төсемін ашу',
      warrantyPeriod: 'Кепілдік кезеңі',
      length: 'Ұзындығы',
      whoAcceptedTheWork: 'Жұмысты кім қабылдады',
      comments: 'Пікірлер',

      addedBy: 'Қосқан',
      pleaseFillInTheHighlightedFields: 'Бөлектелген өрістерді толтырыңыз',
      loadingPleaseWait: 'Жүктелуде, күтіңіз',
      pleaseChooseResponsible: 'Жауапты адамды таңдаңыз',
      pleaseEnterTheStreet: 'Пожалуйста, көшеге кіріңіз',
      pleaseSelectCategory: 'Санатты таңдаңыз',
      selectRoadPlans: 'Жол жоспарларын таңдаңыз',
    },
    configuringUsers: {
      allUsers: 'Барлық пайдаланушылар',
      addUser: 'Пайдаланушыны қосу',
      fullName: 'Аты-жөні',
      login: 'Кіру',
      role: 'Рөлі',
      action: 'Әрекет',
      edit: 'Редакциялау',
      delete: 'Өшіру',
      password: 'Пароль',
      changeUser: 'Пайдаланушыны өзгерту',
      phoneNumber: 'Телефон нөмірі',
      roles: 'Рөлдер',
      addingNewUser: 'Жаңа пайдаланушыны қосу',
      email: 'Электрондық пошта',
      savedBy: 'Сақталған',
      thisUserAlreadyExists: 'Бұл қолданушы бұрыннан бар, басқасын енгізіңіз',
      pleaseEnterAnotherPleaseFillInAllFields: 'Барлық өрістерді толтырыңыз',
      user: 'Пайдаланушы',
      established: 'құрылған',
      removed: 'Жойылды',
      loadingPleaseWait: 'Жүктелуде, күтіңіз',
      regions: 'Аймақтар',
      region: 'Аймақ',
      editUser: 'Пайдаланушыны өңдеу',
    },
    settingUpRoles: {
      allRoles: 'Барлық рөлдер',
      add: 'Қосу',
      delete: 'Өшіру',
      changeCase: 'Істі өзгерту',
      addRole: 'Рөл қосу ',
      code: 'Код ',
      description: 'Сипаттамасы',
      case: 'Модуль',
      action: 'Әрекет',
      edit: 'Редакциялау',
      changingRoles: 'Рөлдерді өзгерту',

      savedBy: 'Сақталған',
      thisUserAlreadyExists: 'Бұл қолданушы бұрыннан бар, басқасын енгізіңіз',
      pleaseEnterAnotherPleaseFillInAllFields: 'Барлық өрістерді толтырыңыз',
      loadingPleaseWait: 'Жүктелуде, күтіңіз',
      addedBy: 'Қосқан',
    },
    settingUpDirectories: {
      categoryReference: 'Санаттар анықтамалығы',
      contractorsDirectory: 'Мердігерлердің анықтамалығы',
      name: 'Атауы',
      responsibleDirectory: 'Жауапты тұлғалардың анықтамалығы',
      delete: 'Өшіру',

      addedBy: 'Қосқан',
      exactlyWantToDelete: 'Дәл жою керек',
      yes: 'Иә',
      no: 'Жоқ',
      enterNewCategory: 'Жаңа санатты енгізіңіз',
      addTo: 'Қосу',
      enterResponsible: 'Жауапты енгізіңіз',
      removed: 'Жойылды',
      plus: 'Қосу',
    },
    userActions: {
      eventView: 'Қарау',
      eventCreate: 'Құрастыру',
      eventUpdate: 'Түзету',
      eventDelete: 'Жою',
      eventOpenCase: 'Модульді ашу',
      serviceName: 'Қызмет аты',
      serviceCode: 'Қызмет коды',
      organization: 'Ұйым',
      modelOrganization: 'Модель',
      chapter: 'Бөлім',
      category: 'Санат',
      subcategory: 'Ішкі санат',
      reportTitle: 'Есеп түрі',
      region: 'Аудан',
      year: 'Жыл',
      month: 'Ай',
      login: 'Логин',
      dateTime: 'Күні',
      action: 'Әрекет',
      object: 'Объект',
      caseName: 'Модуль аты',
      startDate: 'Басы',
      endDate: 'Соңы',
      reset: 'Қалпына келтіру',
      choose: 'Таңдау',
    },
    chartStatus: {
      year: 'Жыл',
      search: 'Іздеу',
      reset: 'Қалпына келтіру',
      organization: 'Ұйым',
      modelOrganization: 'Модель',
      reportTitle: 'Есеп аты',
    },
    gosServiceList: {
      serviceList: 'Қызметтер тізімі',
      eventList: 'Іс-шаралар тізімі',
      charts: 'Есептер',
      createChart: 'Есепті құрастыру',
      chartStatus: 'Есептің статусы',
      successSavingReport: 'Есеп сәтті сақталды',
    },
    health: {
      pageTitle: 'Денсаулық сақтау — нысаналы көрсеткіштер',
      create: 'Құру',
      infoNote:
        'Енгізілген жазбалар hospital_indicators кестесіне сақталады және БҚ негізгі бөлігінде («Денсаулық сақтау» дашбордында) қарауға бірден қолжетімді болады. ' +
        'Деректерді жүргізу әрекеттері пайдаланушы әрекеттерінің журналында тіркеледі.',
      fltPeriod: 'Кезең:',
      fltIndicator: 'Көрсеткіш:',
      allPeriods: 'Барлық кезеңдер',
      allIndicators: 'Барлық көрсеткіштер',
      colInd: 'Көрсеткіш',
      colPeriod: 'Кезең',
      colPlan: 'Жоспар',
      colFact: 'Факт',
      shown: 'Көрсетілген жазбалар:',
      of: 'ішінен',
      mTitle: 'Денсаулық сақтау көрсеткішін енгізу',
      fIndicator: 'Көрсеткіш',
      fType: 'Кезең түрі',
      fYear: 'Жыл',
      fQuarter: 'Тоқсан',
      fUnit: 'Өлшем бірлігі',
      fPlan: 'Жоспарлы мән',
      fFact: 'Нақты мән',
      fDir: 'Бағалау бағыты',
      fNote: 'Ескертпе',
      grpPeriod: 'Есепті кезең',
      year: 'Жыл',
      quarter: 'Тоқсан',
      choose: '— таңдаңыз —',
      autoFill: 'көрсеткіш бойынша толтырылады',
      phNote: 'Енгізілген мәндерге түсініктеме (міндетті емес)',
      optional: 'Міндетті емес өріс.',
      dirLowerBetter: 'жоспардан төмен — жақсы',
      dirHigherBetter: 'жоспардан жоғары — жақсы',
      hintIndicator:
        'Денсаулық сақтау көрсеткіштері анықтамалығынан. Атауын және ' +
        'автоматты түрде өлшем бірлігі мен бағалау бағытын анықтайды.',
      hintType:
        'Анықтамалық мәні: «Жыл» → period_type=Жыл (тоқсан берілмейді); ' +
        '«Тоқсан» → period_type=Квартал және тоқсан нөмірімен.',
      hintUnit:
        'Көрсеткіштер анықтамалығынан автоматты толтырылады. Тек көрсету, есепке әсер етпейді.',
      hintDir:
        'Анықтамалықтан автоматты толтырылады: «жоспардан төмен — жақсы» ' +
        'немесе «жоспардан жоғары — жақсы». Негізгі бөліктегі мәртебе есебін айқындайды.',
      hintPlan: 'Сандық (10,2), ≥ 0. 0 рұқсат етіледі. Сол күйінде сақталады және салыстырылады.',
      hintFact: 'Сандық (10,2), ≥ 0. Орындалу мәртебесін негізгі бөлік есептейді, форма емес.',
      reqMsg: 'Өрісті толтыру міндетті',
      numMsg: '(10,2) форматындағы сан, 0-ден кем емес',
      dupMsg:
        'Бұл көрсеткіш бойынша таңдалған есепті кезеңге жазба бұрыннан бар. Қайталауға болмайды.',
      saveError: 'Көрсеткішті сақтау мүмкін болмады. Қайталап көріңіз.',
      loadError: 'Деректерді жүктеу мүмкін болмады',
      retry: 'Қайталау',
      cancel: 'Болдырмау',
      save: 'Сақтау',
      empty: 'Берілген сүзгілер бойынша жазбалар жоқ',
      toastOk: 'Көрсеткіш сақталды',
      toastSub: 'Жазба тізбеге және пайдаланушы әрекеттерінің журналына қосылды',
      lblYear: 'жыл',
      lblQuarters: ['I тоқсан', 'II тоқсан', 'III тоқсан', 'IV тоқсан'],
      q1: 'I тоқсан',
      q2: 'II тоқсан',
      q3: 'III тоқсан',
      q4: 'IV тоқсан',
    },
    videoStreams: {
      title: 'Бейнеағын — дереккөздер',
      create: 'Құру',
      infoNote:
        'Енгізілген жазбалар БҚ дерекқорында сақталады және БҚ негізгі бөлігінде («Бейнеағын» модулі) таңдау мен қарауға қолжетімді болады. Тізбені жүргізу әрекеттері пайдаланушы әрекеттерінің журналында тіркеледі.',
      colSrc: 'Дереккөз атауы',
      colAddr: 'Бейнеағын мекенжайы',
      colLoc: 'Орналасқан жері',
      colFile: 'Бейнефайл',
      colPlan: 'Жоспарлы мерзім',
      colFact: 'Нақты мерзім',
      emptyTitle: 'Жазбалар жоқ',
      emptyText:
        'Тізбеге әзірге бірде-бір бейнеағын дереккөзі енгізілмеген. Алғашқысын қосу үшін «Құру» түймесін басыңыз.',
      errLoad: 'Бейнеағын дереккөздерінің тізбесін жүктеу мүмкін болмады.',
      retry: 'Қайталау',
      mTitle: 'Бейнеағын дереккөзін құру',
      fSource: 'Дереккөз атауы',
      fAddress: 'Бейнеағын мекенжайы',
      fLocation: 'Орналасқан жері',
      fFile: 'Бейнефайл',
      fPlan: 'Жұмыстарды орындаудың жоспарлы мерзімі',
      fFact: 'Жұмыстарды орындаудың нақты мерзімі',
      phSource: 'Бейнебақылау камерасының атауы',
      phAddress: 'Камера орнатылған мекенжай',
      phLocation: 'Бейнебақылау камерасының орналасқан жері',
      hintLocation: 'БҚ негізгі бөлігінде дөңгелек диаграмманың қимасы ретінде пайдаланылады.',
      hintFile:
        'Жазбаға тіркелетін бейнежазба. Ұсынылатын формат — MP4 (H.264). Шекті өлшемді бейінді бөлімнен нақтылау қажет.',
      optional: 'Міндетті емес өріс.',
      pick: 'Файлды таңдаңыз',
      reqMsg: 'Өрісті толтыру міндетті',
      reqMsgFile: 'Бейнефайлды тіркеңіз',
      cancel: 'Болдырмау',
      save: 'Сақтау',
      errSave: 'Дереккөзді сақтау мүмкін болмады. Қайталап көріңіз.',
      errFile413: 'Файл рұқсат етілген өлшемнен асып тұр. Кішірек файл таңдаңыз.',
      errFile415: 'Қолдау көрсетілмейтін файл форматы. MP4 (H.264) ұсынылады.',
      toastOk: 'Бейнеағын дереккөзі сақталды',
      toastSub: 'Жазба тізбеге және пайдаланушы әрекеттерінің журналына қосылды.',
    },
    dataUpdate: {
      pageTitle: 'Деректерді жаңарту',
      filterPrefix: 'сүзгі',
      filterResult: 'Нәтиже',
      filterModule: 'Модуль / дереккөз',
      filterPeriod: 'кезең',
      dateFrom: 'Жаңартылды: бастап',
      dateTo: 'Жаңартылды: дейін',
      reset: 'Сүзгілерді тазалау',
      dateHint: 'Күндер аралығы белсенді болса, жаңартылмаған модульдер (—) таңдауға кірмейді.',
      all: 'Барлығы',
      success: 'Сәтті',
      error: 'Қате',
      noData: 'Деректер жоқ',
      colModule: 'Функционалдық модуль',
      colSource: 'Ақпараттық жүйе – деректер көзі',
      colDate: 'Соңғы жаңарту күні мен уақыты',
      colCount: 'Алынған жазбалар саны',
      colResult: 'Нәтиже',
      cntTotal: 'Жаңартудағы модульдер',
      cntSuccess: 'Сәтті жаңартылды',
      cntError: 'Қатемен',
      cntNever: 'Жаңартылмаған',
      badgeUnification: 'бірыңғайлау',
      legendSuccess: 'Сәтті — соңғы сеанс сәтті аяқталды',
      legendError:
        'Қате — соңғы сеанс қатемен аяқталды (деректер алдыңғы сәтті сеанстан сақталған)',
      legendNoData: 'Деректер жоқ — жаңарту әлі орындалмаған',
      legendNote: 'Түс көрсеткіштерге қол жеткізуді емес, жүктеу сеансының нәтижесін білдіреді.',
      empty: 'Берілген сүзгілер бойынша жазбалар жоқ',
      loadError: 'Деректерді жүктеу мүмкін болмады',
      retry: 'Қайталау',
      dash: '—',
    },
    analyticsIndicators: {
      title: 'Аналитикалық индикаторлар',
      create: 'Құру',
      reset: 'Тазалау',
      perPage: 'бет',
      retry: 'Қайталау',

      flSearch: 'Іздеу',
      phSearch: 'Индикатор, сала, кезең',
      flIndicator: 'Индикатор',
      flPeriodType: 'Кезең түрі',
      flFrom: 'Кезең басы',
      flTo: 'соңы',
      allItems: 'Барлығы',

      col: {
        indicator: 'Индикатор',
        periodType: 'Кезең түрі',
        period: 'Кезең',
        value: 'Мәні',
        unit: 'Өлш. бір.',
        created: 'Енгізілді',
      },

      emptyTitle: 'Жазбалар табылмады',
      emptyHint: 'Іздеу шарттарын өзгертіңіз немесе сүзгілерді тазалаңыз',
      totalLabel: 'Барлық жазба:',

      selectPlaceholder: '— таңдаңыз —',
      selectYear: 'Жыл',
      phValue: 'Мысалы: 125,2989',

      form: {
        title: 'Индикатор мәнін құру',
        indicator: 'Индикатор',
        periodType: 'Кезең түрі',
        period: 'Кезең',
        value: 'Индикатор мәні',
        unit: 'Өлшем бірлігі',
        comment: 'Дэшбордтағы кезең атауы',
      },

      hint: {
        indicator: 'Салалық индикаторлар «Атауы · Сала» түрінде көрсетілген.',
        unit: 'Индикаторлар анықтамалығынан автоматты түрде толтырылады.',
        comment:
          'Индикатор мен таңдалған кезең бойынша автоматты түрде қалыптастырылады. «Comment» өрісінде сақталады және дэшбордта индикатор мәнінің астында көрсетіледі.',
        period: 'Кезең түрі мен жылды таңдаңыз.',
        value: 'Сандық мән, үтірден кейін 4 таңбаға дейін.',
        half: 'Жартыжылдық мән өспелі қорытындымен II тоқсан ретінде енгізіледі.',
        saved: 'Сақталатын кезең',
      },

      pt: { year: 'Жыл', half: 'Жартыжылдық', quarter: 'Тоқсан', month: 'Ай' },
      halfLabel: 'жартыжылдық',
      quarterLabel: 'тоқсан',

      err: {
        req: 'Өрісті толтыру міндетті',
        num: 'Мән сан болуы тиіс',
        prec: 'Үтірден кейін 4 таңбадан аспауы тиіс',
        neg: 'Мән теріс бола алмайды',
        dup: 'Осы кезеңдегі мән енгізілген',
        future: 'Кезең әлі аяқталмаған',
        save: 'Жазбаны сақтау мүмкін болмады. Қайталап көріңіз',
        saveTitle: 'Сақтау қатесі',
        load: 'Тізбені жүктеу мүмкін болмады. Қайталап көріңіз',
        forbidden: 'Бөлімге қол жеткізуге құқық жеткіліксіз',
      },

      cancel: 'Болдырмау',
      save: 'Сақтау',
      close: 'Жабу',

      view: {
        title: 'Индикатор мәнінің жазбасы',
        noEdit: 'UC.08.02 пайдалану нұсқасында жазбаларды түзету және жою көзделмеген.',
        created: 'Енгізілді',
        by: 'Пайдаланушы',
        range: 'Кезең шекаралары',
        sector: 'Сала',
      },

      toast: {
        ok: 'Индикатор мәні сақталды',
        sub: 'Жазба тізбеге және пайдаланушы әрекеттерінің журналына қосылды.',
        link: 'Журналды ашу',
      },
    },
    budget: {
      title: 'Кірістер мен шығыстар (жинақталған және жинақталмаған)',
      create: 'Кезең бойынша деректерді енгізу',
      tabIncome: 'Кірістер',
      tabExpense: 'Шығыстар',
      fYear: 'Есепті жыл',
      fStatus: 'Күйі',
      stAll: 'Барлық кезеңдер',
      stOn: 'Енгізілген',
      stOff: 'Енгізілмеген',
      colPeriod: 'Есепті кезең',
      colRows: 'Жол',
      colPlan: 'Атқару жоспары',
      colExec: 'Атқарылуы',
      colPct: 'Атқарылу %',
      colState: 'Күйі',
      stateOn: 'Енгізілген',
      stateOff: 'Енгізілмеген',
      actView: 'Қарау',
      actEnter: 'Енгізу',
      emptyList: 'Іріктеу шарттарына сай кезеңдер жоқ',
      loadError: 'Деректерді жүктеу мүмкін болмады',
      retry: 'Қайталау',

      mTitleIncome: 'Кезең бойынша деректерді енгізу — Кірістер',
      mTitleExpense: 'Кезең бойынша деректерді енгізу — Шығыстар',
      vTitleIncome: 'Кезең деректерін қарау — Кірістер',
      vTitleExpense: 'Кезең деректерін қарау — Шығыстар',
      fYear2: 'Есепті жыл',
      fMonth: 'Есепті ай',
      fSection: 'Бюджет тарапы',
      hintSide: 'Тарап тізбе экранында таңдалады; бір формада бір тарап толтырылады.',
      hintUnits:
        'Мәндер жыл басынан бері есепті күнге жинақталған қорытындымен енгізіледі. «Атқарылу %» бағаны автоматты есептеледі және енгізілмейді.',
      selMonth: '— айды таңдаңыз —',
      mNo: '№',
      mCode: 'Код',
      mName: 'Бюджеттік сыныптама топтары (1-деңгей)',
      mPlan: 'Атқару жоспары',
      mExec: 'Атқарылуы',
      mPct: '%',
      mTotal: 'ЖИЫНЫ',

      reqMsg: 'Өрісті толтыру міндетті',
      dupMsg: 'Бұл кезең бойынша деректер енгізілген. Қайта енгізу көзделмеген.',
      errEmpty:
        'Толтырылмаған мәндер: {{n}}. «Атқару жоспары» және «Атқарылуы» барлық торларын толтырыңыз.',
      errNum:
        'Сан пішімі қате жолдар №: {{n}}. Цифрлар, «−» белгісі және бір ондық бөлгіш (4 таңбаға дейін) рұқсат етіледі.',
      errRange:
        'Мән рұқсат етілген шектен асады, жолдар №: {{n}}. Бөлгішке дейін 14 цифрдан және одан кейін 4 цифрдан аспауы тиіс.',
      errNeg: 'Шығыстар бойынша теріс мәндерге жол берілмейді. Жолдар №: {{n}}.',
      warnNeg:
        'Теріс мәндер бюджет қаражатының қалдықтары жолдары бойынша ғана рұқсат етіледі. Жолдарды тексеріңіз №: {{n}}. Сақтау бұғатталмайды.',
      saveError: 'Деректерді сақтау мүмкін болмады',
      progress: '{{b}} жолдың {{a}} толтырылды',
      cancel: 'Болдырмау',
      save: 'Сақтау',
      close: 'Жабу',
      toastOkIncome: '{{p}} кірістері бойынша деректер сақталды',
      toastOkExpense: '{{p}} шығыстары бойынша деректер сақталды',
      toastSub: 'Кезең қайта енгізу үшін жабылды.',
    },
    budgetEntering: {
      pageTitle: 'Кірістер мен шығыстар — деректерді жүргізу',
      tRows: 'Есеп жолдары',
      tImport: 'Файлды жүктеу',
      tBalance: 'Баланс бақылауы',

      rowsTitle: 'Есеп жолдары',
      createRow: 'Жол құру',
      fBudget: 'Бюджет',
      fPeriod: 'Есеп кезеңі',
      fSection: 'Бөлім',
      fDepth: 'Деңгей',
      fSearch: 'Код немесе атауы бойынша іздеу',
      searchPh: '01.01.112 …',
      reset: 'Тазарту',
      allSections: 'Барлық бөлімдер',
      anyLevel: 'Кез келген',
      lvlSection: '0 — жиынтық жол',
      lvlN: '{{n}} деңгей',
      colSection: 'Бөлім',
      colCode: 'Сыныптама коды',
      colName: 'Атауы',
      colUb: 'Нақтыланған',
      colAdj: 'Түзетілген',
      colPp: 'Кезең жоспары',
      colEx: 'Орындалу',
      colP1: 'жоспарға %',
      colActions: '',
      noRows: 'Берілген шарттар бойынша жолдар табылмады',
      noName: 'дереккөзде атауы жоқ',
      edit: 'Өңдеу',
      totalRows: 'Барлық жазба: {{n}}',
      perPage: 'бет.',
      partial: 'толық емес',
      onDate: 'күні',
      mRowCreate: 'Есеп жолы — құру',
      mRowEdit: 'Есеп жолы — өңдеу',
      refFormNote:
        '<b>Анықтамалық жол.</b> Оған 1-27 нысанында жылдық бюджет пен төлем жоспары толтырылмайды — тиісті блоктар жасырылған. Тек атқарылу сомасын енгізіңіз.',
      s1Title: 'Есеп бөлімі және бюджеттік сыныптама коды',
      lSection: 'Есеп бөлімі',
      hSection: 'Баланс жағын анықтайды. Бөлім жолдың орнынан емес, есеп құрылымынан алынады.',
      lLevel: 'Ішкі деңгей',
      hLevel: 'Толтырылған кодтар саны бойынша автоматты есептеледі.',
      lCodes: 'Бюджеттік сыныптама кодтары (код 1 → код 6)',
      hCodes:
        'Солдан оңға қарай үзіліссіз толтырылады. Алтауы бос болса — бөлімнің жиынтық жолы. Алдыңғы нөлдер маңызды: «01» мен «1» — әртүрлі кодтар.',
      lName: 'Жол атауы',
      lNoName: 'Дереккөзде атауы жоқ («000» ішкі бағдарламасы)',
      hName:
        'Жалауша тек «Қазынашылық» АЖ шығарылымында атау ұяшығы шынымен бос болса қойылады. Мұндай жолдар жылдық бюджетті көтереді және жойылмауға тиіс.',
      s2Title: 'Жылдық бюджет',
      lAb: 'Бекітілген бюджет',
      hAb: 'Есептің 3-бағанасы. Мың теңге, 5 таңбаға дейін.',
      lUb: 'Нақтыланған бюджет',
      hUb: 'Есептің 4-бағанасы.',
      lAdj: 'Түзетілген бюджет',
      hAdj: '5-баған. Дашбордтағы «бюджетке %» базасы осы.',
      s2Note:
        '«000» ішкі бағдарлама жолдарында (атауы жоқ) тек бекітілген және нақтыланған бюджет толтырылған, түзетілген, жоспар мен орындалу нөлге тең. Нақты ішкі бағдарлама жолдарында — керісінше. Бұл сыныптама бойынша қалыпты бөлініс, нөлдер саналы түрде енгізіледі.',
      s3Title: 'Есепті кезеңге жоспар және міндеттемелер',
      lPp: 'Төлемдер бойынша жиынтық жоспар',
      hPp: '6-баған. Жылға емес, есепті кезеңге жоспар.',
      lCp: 'Міндеттемелер бойынша жиынтық жоспар',
      hCp: '7-баған.',
      lCa: 'Қабылданған міндеттемелер',
      hCa: '8-баған.',
      lUa: 'Төленбеген міндеттемелер',
      hUa: '9-баған.',
      s4Title: 'Орындалу және бақылау',
      lEx: 'Орындалу',
      hEx: '10-баған. Теріс болуы мүмкін (қайтарымдар).',
      lP1: 'кезең жоспарына %',
      hP1: 'Жүйе сомалардан есептейді. Жоспар 0 болса — «—».',
      lP2: 'орындалатын бюджетке %',
      hP2: 'Орындалу / түзетілген бюджет.',
      hРrefPct:
        'Анықтамалық жолдар үшін пайыздар есептелмейді: оларда жоспар мен жылдық бюджет жоқ.',
      s4Checks: 'Жолдың автоматты тексерулері',
      chkOblig: 'Қабылданған минус төленбеген міндеттемелер орындалуға тең',
      chkOffPlan: 'Орындалу нөл емес кезде кезең жоспары нөл — рұқсат етіледі, бірақ тексеріңіз',
      chkAdjZero: 'Нақтыланған нөл емес кезде түзетілген бюджет нөл — «000» жолдарына тән',
      chkNeg: 'Теріс орындалу — рұқсат етіледі (қайтарымдар), таңбасын тексеріңіз',
      chkNone: 'Жол бойынша ескертпе жоқ',
      cancel: 'Болдырмау',
      save: 'Сақтау',
      refClearAsk:
        'Анықтамалық жолдар үшін жылдық бюджет пен төлем жоспары есепте толтырылмайды. Енгізілген мәндер тазаланады. Жалғастырасыз ба?',
      closeAsk: 'Сақтамай жабылсын ба?',
      eReq: 'Өріс толтырылуы міндетті',
      eNum: 'Тек сан, үтірден кейін 5 таңбаға дейін',
      eGap: 'Кодтар солдан оңға үзіліссіз толтырылады',
      eLen10: 'Код 10 таңбадан ұзын болмауы керек',
      eCodeFmt: 'Кодта тек цифрлар мен латын әріптері болуы мүмкін',
      eLen500: 'Атау 500 таңбадан ұзын болмауы керек',
      eDup: 'Осы кезеңде мұндай бөлім мен коды бар жол әлдеқашан бар',
      eNoParent: 'Осы бөлім мен кезеңде «{{p}}» аталық түйіні табылмады',
      impTitle: 'Есепті файлдан жүктеу',
      lIBudget: 'Бюджет түрі',
      lIFile: 'Есеп файлы',
      btnImport: 'Жүктеу',
      impNoFile: 'Есеп файлын таңдаңыз',
      impDone: 'Файл жүктелді, теңдіктер сәйкес келді',
      impDoneViol: 'Файл жүктелді, бірақ баланс теңдіктері сәйкес келмейді',
      impStats:
        '«{{f}}» файлынан жүктелген жолдар: {{n}}. Есепті күн: {{d}}. Деректер дашбордта қолжетімді.',
      impViolNote:
        'Деректер сақталды және дашбордта тұтастықтың бұзылуы туралы ескертумен көрінеді. Бастапқы файлды тексеріңіз.',
      impRegion:
        'Файл «{{fr}}» аймағы бойынша қалыптастырылған, ал «{{cr}}» бюджеті таңдалған. Бюджет түрін тексеріңіз.',
      impParseTitle:
        'Файлды талдау қатесі. Бірде-бір жол сақталмады, кезеңнің бұрынғы деректері өзгерген жоқ.',
      impLine: '{{n}}-жол: {{m}}',
      impSaved: 'Кезең жүктелді',
      balNote:
        'Экран кезеңнің енгізілген деректері бойынша баланс теңдіктерінің сәйкестігін көрсетеді. Кемінде бір тексеру қызыл болса, кезең аяқталмаған болып саналады: Ситуациялық орталық дашборды ол бойынша тұтастықтың бұзылуы туралы ескерту шығарады. Түзету керегі — енгізілген жолдар, жиынтықты күштеп келтіру емес.',
      balTitle: 'Кезеңнің баланс теңдіктерін бақылау',
      balChecks: 'Тексерулер',
      kRes: 'Жиыны ресурстар',
      kUse: 'Жиыны пайдалану',
      kResid: 'Айырма',
      kDef: 'Тапшылық',
      kSur: 'Профицит',
      id1: 'Тапшылық кірістер минус шығындар және III–IV бөлімдерге тең',
      id2: 'Тапшылықты қаржыландыру тапшылыққа кері таңбамен тең',
      id3: 'Таза бюджеттік кредиттеу беру минус өтеуге тең',
      id4: 'Қаржы активтері бойынша сальдо сатып алу минус түсімдерге тең',
      id5: 'Пайдаланылған қалдықтар басындағы минус соңындағы қалдыққа тең',
      id6: 'Жиыны ресурстар жиыны пайдалануға тең',
      id9: 'Тапшылықты қаржыландыру қарыздар минус өтеу қосу пайдаланылған қалдықтарға тең',
      resid: 'айырма',
      balMissing: 'Толық емес деректер бойынша тексерілді: {{s}} бөлімдері енгізілмеген',
      balCarry: 'Жыл басындағы қалдық алдыңғы кезең соңындағы қалдықпен сәйкес келеді',
      toLog: 'Әрекеттер журналын ашу',
      toastSaved: 'Жол сақталды. Жазба Ситуациялық орталық дашбордында қолжетімді.',
      toastPeriod: 'Кезең құрылды. Енді оған жолдар енгізуге болады.',
      toastSaveErr: 'Сақталмады: толтырылмаған немесе қате өрістер бар.',
      toastConflict: 'Жазба басқа пайдаланушымен өзгертілді, форманы жаңартыңыз.',
      refresh: 'Жаңарту',
      toastNet: 'Сервер қолжетімсіз, өзгерістер сақталмады.',
      retry: 'Қайталау',
      loadError: 'Деректерді жүктеу мүмкін болмады',
    },
    schools: {
      title: 'Мектептер — білім беру ұйымдарының тізбесі',
      create: 'Құру',

      fltShift: 'Ауысымдылық:',
      fltLang: 'Оқыту тілі:',
      allShifts: 'Барлық ауысымдар',
      allLangs: 'Барлық тілдер',

      colSchool: 'Мектеп',
      colCap: 'Қуаты',
      colStudents: 'Оқушылар',
      colTeachers: 'Мұғалімдер',
      colShift: 'Ауысымдылық',
      colLang: 'Оқыту тілі',

      shown: 'Көрсетілген жазбалар:',
      of: 'ішінен',
      noRows: 'Таңдалған сүзгілер бойынша жазба жоқ',
      loadError: 'Мектептер тізбесін жүктеу мүмкін болмады',
      retry: 'Қайталау',

      mTitle: 'Мектеп туралы жазба құру',
      fName: 'Мектеп атауы',
      fAddr: 'Мекенжайы',
      fShift: 'Ауысымдылық',
      fLang: 'Оқыту тілі',
      fCap: 'Жобалық қуат, орын',
      fStudents: 'Оқушылар саны',
      fTeachers: 'Мұғалімдер саны',
      fDeficit: 'Орын тапшылығы',
      fSurplus: 'Орын профициті',
      grpCap: 'Қуаты және контингенті',
      grpAuto: 'Есептік өрістер',

      langKz: 'Қазақ',
      langRu: 'Орыс',
      langBoth: 'Қазақ және орыс',

      phName: 'Білім беру ұйымының атауы',
      phAddr: 'Индекс, елді мекен, көше, үй',
      autoFill: 'автоматты есептеледі',
      optional: 'Міндетті емес өріс.',

      hintCap: 'Бүтін сан, 1-ден кем емес.',
      hintStudents: 'Бүтін сан, 0-ден кем емес.',
      hintTeachers: 'Бүтін сан, 0-ден кем емес.',
      hintDeficit: 'Оқушылар минус қуат, бірақ 0-ден кем емес.',
      hintSurplus: 'Қуат минус оқушылар, бірақ 0-ден кем емес.',

      reqMsg: 'Өрісті толтыру міндетті',
      numMsg: 'Бүтін сан, 0-ден кем емес',
      capMsg: 'Бүтін сан, 1-ден кем емес',
      langMsg: 'Кемінде бір оқыту тілін белгілеңіз',
      dupMsg: 'Мұндай атаумен мектеп тізбеде бар. Қайталауға болмайды.',
      saveError: 'Жазбаны сақтау мүмкін болмады. Қайталап көріңіз.',

      cancel: 'Болдырмау',
      save: 'Сақтау',

      toastOk: 'Мектеп туралы жазба сақталды',
      toastSub: 'Жазба тізбеге және',
      toastLog: 'пайдаланушы әрекеттерінің журналына қосылды',
    },
    preSchool: {
      title: 'Білім беру — мектепке дейінгі ұйымдар',
      create: 'Құру',
      fSearch: 'Іздеу',
      phSearch: 'Атауы немесе мекенжайы',
      fLoc: 'Елді мекен',
      allLoc: 'Барлық елді мекендер',
      fType: 'МДҰ түрі',
      allType: 'Барлық түрлері',
      fState: 'Толымдылығы',
      allState: 'Кез келген жай-күй',
      reset: 'Тазалау',
      emptyList: 'Жазбалар табылмады',
      found: 'Табылған жазбалар: {n}',
      toastOk: '«{n}» ұйымы құрылды',
      toastSub: 'Жазба журналға қосылды.',

      // ── Колонки таблицы ────────────────────────────────────────
      colName: 'Атауы',
      colLoc: 'Елді мекен',
      colType: 'МДҰ түрі', // [confirm]
      colLang: 'Оқыту тілі',
      colForm: 'Мекеме нысаны',
      colSeats: 'Жобалық қуаты',
      colKont: 'Нақты толуы',
      colState: 'Толымдылығы',
      colActive: 'Мәртебесі',
      actOn: 'Белсенді',
      actOff: 'Белсенді емес',

      // ── Состояния наполненности ────────────────────────────────
      stProf: 'Профицит', // [confirm] вариант: «Бос орын бар»
      stNorm: 'Норма', // [confirm] вариант: «Қалыпты»
      stDefic: 'Тапшылық', // [confirm] калька: «Дефицит»
      stND: 'Дерек жоқ',

      // ── Модальная форма ────────────────────────────────────────
      mTitle: 'Мектепке дейінгі ұйымды құру',
      footNote: 'Жұлдызшамен (*) белгіленген өрістер міндетті.',
      cancel: 'Болдырмау',
      save: 'Сақтау',
      selPlaceholder: '— таңдаңыз —',
      optional: 'Міндетті емес өріс.',

      // Секция 1
      secGeneral: 'Ұйым туралы мәліметтер',
      fName: 'Ұйым атауы',
      phName: 'Мектепке дейінгі ұйымның толық атауы',
      fAddr: 'Мекенжайы',
      phAddr: 'Мектепке дейінгі ұйымның мекенжайы',
      fDistrict: 'Аудан',
      fCoords: 'Координаттар (ендік, бойлық)',
      phLat: 'ендік',
      phLon: 'бойлық',
      hintCoords:
        'Міндетті емес. Үтірден кейін 6 таңбаға дейін. Негізгі бөлімнің картасында көрсету үшін пайдаланылады.',

      // Секция 2
      secClass: 'Жіктелуі (дэшборд қималары)',
      fForm: 'Мекеме нысаны',
      fTypeF: 'МДҰ түрі', // [confirm]
      fLang: 'Оқыту тілі',
      hintLang: '«Аралас» — оқыту қазақ және орыс тілдерінде жүргізіледі.',
      fTime: 'Болу ұзақтығы',

      // Секция 3
      secCounts: 'Толымдылық және кезек көрсеткіштері',
      fSeats: 'Жобалық қуаты',
      phSeats: 'орын',
      fKont: 'Нақты толуы',
      phKont: 'бала',
      fFree: 'Бос орындар',
      fQueue: 'Кезекте',
      fNapr: 'Жолдама берілді',
      fZach: 'Қабылданды',
      calcDev: 'Ауытқу (қуаты − нақты):',
      calcState: 'Толымдылық жай-күйі:',
      calcHint: 'Сақтау кезінде БҚ автоматты есептейді, қолмен енгізілмейді.',

      // Секция 4
      secMeta: 'Есептілік және есепке алу',
      fPeriod: 'Есепті кезең',
      fActive: 'Белсенділік мәртебесі',
      hintActive: '«Белсенді емес» — ұйым дэшборд құру кезінде ескерілмейді.',

      // Валидация / ошибки
      reqMsg: 'Өрісті толтыру міндетті',
      numMsg: 'Тек бүтін сан рұқсат етіледі (≥ 0)',
      numMsgCoords: 'Тек сан рұқсат етіледі (үтірден кейін 6 таңбаға дейін)',
      alertReq: 'Міндетті өрістерді тексеріңіз.',
      alertServer: 'Сервер қатесі. Кейінірек қайталап көріңіз.',
    },
  },
};

export default Kz;
